import {Money} from '@dms/api/shared';

import type {FileData} from './FileData';
import type {PaymentDiscriminatorEnum} from './PaymentDiscriminatorEnum';
import type {PaymentMethodEnum} from './PaymentMethodEnum';
import type {PaymentStateEnum} from './PaymentStateEnum';
import type {TenantBankAccount} from './TenantBankAccount';

export type OrderPayment = {
  id: string;
  paymentDiscriminator: PaymentDiscriminatorEnum;
  paymentMethod: PaymentMethodEnum;
  amount: Money | null;
  payDate: string | null;
  issuedOn: string | null;
  dueDate: string | null;
  customerBankAccountId: string | null;
  tenantBankAccount: TenantBankAccount | null;
  cashRegisterId: string | null;
  paymentState: PaymentStateEnum;
  files: Array<FileData>;
  comment: string | null;
  invoices: Array<FileData>;
  proformaInvoices: Array<FileData>;
  taxableDocuments: Array<FileData>;
  cashReceipts: Array<FileData>;
  correctiveTaxDocuments: Array<FileData>;
  invoiceId: string | null;
  proformaInvoiceId: string | null;
  taxDocumentId: string | null;
  internalInvoiceDocuments: Array<FileData>;
  createCashRegisterDocument: boolean | null;
  cashRegisterDocumentId: string | null;
  exchangeRate: string | null;
  foreignCurrencyAmount: Money | null;
  supplierInvoiceNumber: string | null;
};
